import React from 'react'
import { IonItem } from '@ionic/react'
import QRCode from 'qrcode.react'
import { getStyleForPHI, IPHIComponent } from '../phi/phi.component'

export interface IQRCode extends IPHIComponent {
  value: string
  size?: number
  includeMargin?: boolean
  bgColor?: string
  fgColor?: string
  level?: 'L' | 'M' | 'Q' | 'H'
  dataTestID?: string
}

const QRCodeComponent: React.FC<IQRCode> = (props: IQRCode) => {
  const { value, size, includeMargin, level, dataTestID, isPHI } = props

  return (
    <IonItem data-private={isPHI} style={getStyleForPHI(isPHI)} lines='none'>
      <QRCode
        data-testid={dataTestID}
        value={value}
        size={size}
        level={level}
        renderAs='svg'
        includeMargin={includeMargin}
      />
    </IonItem>
  )
}

export default QRCodeComponent
